import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { toast } from 'react-toastify';

function Register({ setAuth }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '', email: '', password: '', confirmPassword: '', companyName: ''
  });
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (formData.password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    if (!termsAccepted) {
      setError('Please accept the Terms of Service and Privacy Policy to continue');
      return;
    }

    setLoading(true);
    try {
      const res = await authAPI.register({
        fullName: formData.fullName,
        email: formData.email,
        password: formData.password,
        companyName: formData.companyName
      });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      setAuth(true);
      toast.success('Account created!');
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '10px 12px', border: '1px solid #E2E8F0',
    borderRadius: 8, fontSize: 14, fontFamily: 'var(--font-body)',
    boxSizing: 'border-box', outline: 'none'
  };

  const labelStyle = {
    display: 'block', fontSize: 12, fontWeight: 700, color: '#374151',
    textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 5,
    fontFamily: 'var(--font-body)'
  };

  return (
    <div style={{ minHeight: '100vh', background: '#F8FAFC', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 16, padding: '40px 36px', width: '100%', maxWidth: 440, border: '1px solid #E2E8F0' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontFamily: 'var(--font-heading)', fontSize: 22, fontWeight: 800, letterSpacing: '-0.5px', marginBottom: 6 }}>
            <span style={{ color: '#0066FF' }}>Air</span><span style={{ color: '#0A1628' }}>Comply</span>
          </div>
          <div style={{ fontFamily: 'var(--font-body)', fontSize: 14, color: '#6B7280' }}>Create your account</div>
        </div>

        {error && (
          <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 13, color: '#DC2626', fontFamily: 'var(--font-body)' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>Full Name</label>
            <input type="text" required value={formData.fullName}
              onChange={e => setFormData({...formData, fullName: e.target.value})}
              placeholder="Jane Smith" style={inputStyle} />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>Company Name</label>
            <input type="text" required value={formData.companyName}
              onChange={e => setFormData({...formData, companyName: e.target.value})}
              placeholder="ABC Manufacturing" style={inputStyle} />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>Email Address</label>
            <input type="email" required value={formData.email}
              onChange={e => setFormData({...formData, email: e.target.value})}
              placeholder="jane@company.com" style={inputStyle} />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>Password</label>
            <input type="password" required value={formData.password}
              onChange={e => setFormData({...formData, password: e.target.value})}
              placeholder="Min 8 characters" style={inputStyle} />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={labelStyle}>Confirm Password</label>
            <input type="password" required value={formData.confirmPassword}
              onChange={e => setFormData({...formData, confirmPassword: e.target.value})}
              placeholder="Repeat password" style={inputStyle} />
          </div>

          {/* Terms checkbox */}
          <div style={{ marginBottom: 20, display: 'flex', alignItems: 'flex-start', gap: 10 }}>
            <input
              type="checkbox"
              id="terms"
              checked={termsAccepted}
              onChange={e => setTermsAccepted(e.target.checked)}
              style={{ marginTop: 3, width: 'auto', flexShrink: 0, cursor: 'pointer' }}
            />
            <label htmlFor="terms" style={{ fontSize: 13, color: '#374151', fontFamily: 'var(--font-body)', lineHeight: 1.5, cursor: 'pointer' }}>
              By creating an account I agree to AirComply's{' '}
              <a href="https://aircomply.com/terms.html" target="_blank" rel="noopener noreferrer"
                style={{ color: '#0066FF', textDecoration: 'none', fontWeight: 600 }}>Terms of Service</a>
              {' '}and{' '}
              <a href="https://aircomply.com/privacy.html" target="_blank" rel="noopener noreferrer"
                style={{ color: '#0066FF', textDecoration: 'none', fontWeight: 600 }}>Privacy Policy</a>
            </label>
          </div>

          <button type="submit" disabled={loading || !termsAccepted}
            style={{
              width: '100%', padding: '11px', background: loading || !termsAccepted ? '#94a3b8' : '#0066FF',
              color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700,
              cursor: loading || !termsAccepted ? 'not-allowed' : 'pointer',
              fontFamily: 'var(--font-body)'
            }}>
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <span style={{ fontSize: 13, color: '#6B7280', fontFamily: 'var(--font-body)' }}>
            Already have an account?{' '}
            <Link to="/login" style={{ color: '#0066FF', fontWeight: 600, textDecoration: 'none' }}>Sign in</Link>
          </span>
        </div>

        {/* Legal footer */}
        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: '#94a3b8', fontFamily: 'var(--font-body)', lineHeight: 1.6 }}>
          © 2026 AirComply Inc. ·{' '}
          <a href="https://aircomply.com/terms.html" target="_blank" rel="noopener noreferrer"
            style={{ color: '#94a3b8', textDecoration: 'none' }}>Terms</a>
          {' '}·{' '}
          <a href="https://aircomply.com/privacy.html" target="_blank" rel="noopener noreferrer"
            style={{ color: '#94a3b8', textDecoration: 'none' }}>Privacy</a>
        </div>
      </div>
    </div>
  );
}

export default Register;
